//import './style.scss';
import './companyresult.scss';
import { useEffect, useRef } from "react";
import { useState } from 'react';
import { IFeature } from '@esri/arcgis-rest-types';
import { IRelatedRecordGroup } from '@esri/arcgis-rest-feature-layer';
import QueryService from '../../shared/queryService';
import ConfigService from '../../shared/configService';
import Utils from '../../shared/utils';
import { useTranslation } from "react-i18next";
import IReport from '../../models/IReport';
import { IPSDashboard, IReportMain } from '../../models/IConfig';
import LoadingOverlay from 'react-loading-overlay';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import PSDetailDashboard from './PSDetailDashboard';
import { PSReportList } from './components/PSReportList';

const PSDashboard = () => {

    const { t } = useTranslation('psdashboard');
    const reportMainConfig: IReportMain = ConfigService.getConfig().agol.operationalLayers.reportMain;
    const psDashboardConfig: IPSDashboard = ConfigService.getConfig().psdashboard;

    interface IDataState {
        reports: IReport[],
        companies: any[],
        totalCompanies: number,
        TotalHAUnderRestoration: string
    }

    interface ILocalState {
        selectedPS: string,
        reportsLoaded: boolean,
        queryParams: any
    }

    /**
   * State
   */
    const [showDetailDashboard, setShowDetailDashboard] = useState(false);

    const handleDetailDashboardClose = () => {
        setShowDetailDashboard(false);
    }

    const handleDetailDashboardShow = (companyName: string) => {
        let obj: any = { ...state };
        obj["selectedPS"] = companyName;
        setState(obj);
        setShowDetailDashboard(true);
    }

    const [dataState, setDataState] = useState<IDataState>({
        reports: [],
        companies: [],
        totalCompanies: 0,
        TotalHAUnderRestoration: ""
    });

    const [state, setState] = useState<ILocalState>({
        selectedPS: 'NONE',
        reportsLoaded: false,
        queryParams: queryString.parse(useLocation().search)
    });

    useEffect(() => {

        console.log(state.queryParams);
        getData();

    }, []);

    const getRelatedFeatures = async (sourceFeatures: IFeature[], relatedTableName: String, url: string, relationshipId: number, objectIds: number[], outFields: '*' | string[] | undefined = '*'): Promise<IFeature[]> => {
        try {
            let resulfeatures = sourceFeatures;

            if (objectIds && objectIds.length > 0) {
                const relatedRecords: IRelatedRecordGroup[] = await QueryService.queryRelatedFeatures(url, relationshipId, objectIds, false, outFields, '', false);

                if (relatedRecords && relatedRecords.length > 0) {

                    resulfeatures = sourceFeatures.map((feature: IFeature) => {

                        const relatedRecord: IRelatedRecordGroup | undefined = relatedRecords.find((item: IRelatedRecordGroup) => item.objectId == feature.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid]);
                        if (relatedRecord && relatedRecord.relatedRecords && relatedRecord.relatedRecords.length > 0) {
                            if (typeof outFields === "object") {
                                for (let i = 0; i < outFields.length; i++) {
                                    //outFields.map( (field:String) => {
                                    const field = outFields[i];
                                    const sum = relatedRecord.relatedRecords.reduce((prev: number, current: IFeature) => {
                                        return prev + (current.attributes[field] as number);
                                    }, 0);
                                    feature.attributes["sum_" + field] = sum;
                                }
                            }
                        }
                        return feature;
                    });
                }
            }
            return resulfeatures;

        } catch (err: any) {
            console.error(err);
            return Promise.reject(err);
        }
    }

    const onselectedGID = async (companyName: string) => {
        handleDetailDashboardShow(companyName)
    }

    const getData = async () => {
        Utils.setStateValue("reportsLoaded", false, state, setState);
        const report_type = '2';
        let where = `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.reportingEntityType}` + ' = ' + report_type + ' and published = 1'

        let reportFeatures = await QueryService.queryFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), where, false, '*', `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear} ASC`, null, false);
        const objectIdsReports: number[] = reportFeatures.map((feat: IFeature) => { return feat.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid] });
        //query to related ReportRB
        reportFeatures = await getRelatedFeatures(reportFeatures, ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRb.toString(), Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRb, objectIdsReports, ["ha_under_resto", "co2_sequestered", "eco_jobs_created"]);
        reportFeatures = await getRelatedFeatures(reportFeatures, ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportFinancialFlows.toString(), Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportFinancialFlows, objectIdsReports, ["amount"]);

        const reports: IReport[] = reportFeatures.map((feat: IFeature) => {

            const id: number = Number(feat.attributes[reportMainConfig.fields.objectid]);
            const company: String = String(feat.attributes[reportMainConfig.fields.companyName]);
            const published: boolean = feat.attributes[reportMainConfig.fields.published];
            const submitted: boolean = feat.attributes[reportMainConfig.fields.submitted];

            const zone: string = company ? `${company} (Company)` : '';
            const status: any = published && submitted ? 'Published' : !published && submitted ? 'Submitted' : 'Saved';
            let attr: any = {};
            for (const key in feat.attributes)
                attr[key] = feat.attributes[key];
            attr.zone = zone;
            return attr;
        });
        const distinctCompany: Array<String> = reports.sort((a: any, b: any) => (a.company_name.trim() > b.company_name.trim() ? 1 : -1)).map((report: any) => report.company_name.trim()).filter((value, index, self) => self.indexOf(value) === index);

        const total_sum_ha_under_resto = reportFeatures.reduce(function (prev: number, current: IFeature) {
            if (current.attributes["sum_ha_under_resto"] != undefined) {
                return prev + current.attributes["sum_ha_under_resto"]
            }
            else {
                return prev;
            }

        }, 0);

        setDataState({
            reports: reports,
            companies: distinctCompany,
            totalCompanies: distinctCompany.length,
            TotalHAUnderRestoration: total_sum_ha_under_resto.toLocaleString()
        });

        // Set selected year
        let obj: any = { ...state };
        obj["selectedPS"] = '';
        obj["reportsLoaded"] = true;
        setState(obj);
    };

    return (
        <>
            <div className={`dashboardDiv ${showDetailDashboard ? "notdisplay" : ""}`}>
                <div className="page-header">
                    <div className="contained">
                        <span className="page-title">{t('title')}</span>
                    </div>
                </div>
                <div className="content-wrapper">
                    {dataState.companies.length > 0 &&
                        <div className="company-result">
                            <div className="contained company-result-contained">
                                <div className="info">
                                    <div className="info-text">
                                        <p>
                                            <strong>{dataState.totalCompanies}</strong>
                                            <span>{dataState.totalCompanies && dataState.totalCompanies > 1 ? t('filter.totalCompaniesMultiple') : t('filter.totalCompaniesSingle')}</span>
                                        </p>
                                    </div>
                                    <div className="info-text">
                                        <p>
                                            <strong>{dataState.TotalHAUnderRestoration}</strong>
                                            <span>{t('filter.totalhaUnderRestoration')}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {state.reportsLoaded &&
                        <>
                            <PSReportList reports={dataState.companies} selectedPS={state.selectedPS} onClickedCompany={onselectedGID} />
                        </>
                    }
                    <LoadingOverlay
                        active={!state.reportsLoaded}
                        spinner
                        text={!state.reportsLoaded ? t('loading') : ''} >
                    </LoadingOverlay>
                </div>

            </div>
            {showDetailDashboard && state.selectedPS &&
                <PSDetailDashboard selectedPS={state.selectedPS} onClose={handleDetailDashboardClose} />
            }
        </>

    )

};

export default PSDashboard;

